import { createSlice } from '@reduxjs/toolkit';
import type { CandidatesStatusState } from '../features/dashBoard/types';

const initialState: CandidatesStatusState = {
  data: null,
  status: 'idle',
};

export const candidatesSlice = createSlice({
  name: 'dashBoard',
  initialState,
  reducers: {
    setCandidatesStatusData: (state, action) => {
      state.data = action.payload;
      state.status = 'succeeded';
    },
    clearCandidatesStatus: (state) => {
      state.data = null;
      state.status = 'idle';
    },
  },
});

export const {
  setCandidatesStatusData,
  clearCandidatesStatus,
} = candidatesSlice.actions;
export default candidatesSlice.reducer;
